<template>
  <div class="Appdownload">
    <div class="bigImg">
        <img class="topimg" src="../../static/wap/index/top.png" alt="" />
      <div class="title">细致交易</div>
      <div class="title">风险防控</div>
      <div class="titles">一机在手，指尖盈利</div>
      <img class="download" @click="scrollToTarget" src="../../static/wap/index/download.png" alt="" />
       <!-- <div class="topbox">
        <div class="flex boxs"  >
          <div class="left flex1">A</div>
          <div class="right">
            <span class="txts">伦敦金</span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ golds||0 }}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class=" left flex1 " style="background: #A915AC;" >B</div>
          <div class="right">
            <span class="txts">伦敦银</span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ sliver||0}}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange1.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class=" left flex1 " style="background: #15AC36">C</div>
          <div class="right">
            <span class="txts">美国原油 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ usd }}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange2.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class="left flex1">D</div>
          <div class="right">
            <span class="txts">纳斯达克指数 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ nas}}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange3.value||0 }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class="left flex1">E</div>
          <div class="right">
            <span class="txts">恒生指数 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ hk50 }}</span>
              <span class="txt" style="color: #fa2314">{{ priceRange4.value||0 }}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="iconBox">
       <div class="indexTitle"><span>即刻下载</span></div>
       <div class="indexTitle">掌控您的财富先机</div>
      <div class="indexTitle1 part-tit">智赢未来，开启财富增长新篇章</div>
      <div class="indexTitle1 part-tit">指尖轻触，商机尽在掌握</div>
      <div class="ibsBox">
       <img src="../../static/wap/download/computed.png" alt="">
       <img class="phone" src="../../static/wap/download/phone.png" alt="">
       <img class="phone1" src="../../static/wap/download/phone1.png" alt="">
       <img class="icon1" src="../../static/wap/download/icon1.png" alt="">
       <img class="icon2" src="../../static/wap/download/icon2.png" alt="">
       <img class="icon3" src="../../static/wap/download/icon3.png" alt="">
       <img class="icon4" src="../../static/wap/download/icon4.png" alt="">
       <img class="icon5" src="../../static/wap/download/icon5.png" alt="">
       <img class="icon6" src="../../static/wap/download/icon6.png" alt="">
      </div>
    </div>
    <div class="part2" ref="targetElement">
      <div class="indexTitle"><span>下载</span>红狮APP</div>
      <div class="indexTitle1">
        多功能一站式平台，为您提供伦敦金、伦敦银等品种的开户、交易、出入金、产品报价、行情资讯、财经新闻、专家解盘、24h客服团队等服务，让您不惧时间和空间限制，随时随地使用手机进行交易。
      </div>
      <img class="phone" src="../../static/wap/index/phone.png" alt="" />
      <div class="part2-bott">
        <div>
          <img class="icons" src="../../static/wap/download/icon7.png" alt="" />
          <span>顶尖团队倾力打造</span>
        </div>
        <div>
          <img class="icons" src="../../static/wap/download/icon8.png" alt="" />
          <span>千日精心打磨细节</span>
        </div>
        <div>
          <img class="icons" src="../../static/wap/download/icon9.png" alt="" />
          <span>200+万用户使用</span>
        </div>
        <div>
          <img class="icons" src="../../static/wap/download/icon10.png" alt="" />
          <span>权威平台广泛认可</span>
        </div>
      </div>
      <div class="part2-down" v-if="showAndroid">
        <div class="code">
          <canvas class="canvasCode" ref="qrcodeCanvas"></canvas>
        </div>
        <div class="flexs">
          <img
            class="download"
            src="../../static/wap/download/android.png"
            @click="androidDownload"
            alt=""
          />
          <img class="download" @click="iosDownload" src="../../static/wap/download/ios.png" alt="" />
          <span>扫码下载 {{appName}}APP</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getChannelInfo, getConfigurationValue } from "@/apis/common";

import eventBusMitter from '../../utils/eventbus'

  import { generateQRCode } from "../../utils/tools";
import { getActiveDomain } from '../../utils/IMEI'

  export default {
    name: "Appdownload",
    metaInfo: {  
      title: '红狮金业APP,现货黄金白银投资专业软件,伦敦金伦敦银靠谱平台,黄金交易红狮启富APP',
      meta: [
        { name: 'keywords', content: '红狮金业,红狮启富,黄金交易平台,贵金属交易软件,贵金属投资APP,贵金属平台,现货黄金开户,现货白银,正规靠谱平台' },
        { name: 'description', content: '红狮金业APP是一款稳定安全的交易软件,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }
      ]  
    },  
    data(){
      return{
        iosUrl: 'https://apps.apple.com/us/app/id6451142175',
         topData: [
        {
          name: "A",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
        {
          name: "B",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
        {
          name: "C",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
      ],
      appName:'红狮乐富',
        showAndroid:true,
      
      }
    },
    created(){
      const Rhref = window.location.host;

      if (Rhref.indexOf('hspluspro') > -1) {
        this.appName = '乐富智享'
      }
      if (Rhref.indexOf('rlctop') > -1) {
        this.showAndroid = false
      }
      eventBusMitter.emit('eventtab', { key: false })

      this.$emit('controlShow', false);
      const channel = sessionStorage.getItem('channel');

      this.getAndroidUrl(channel);
      this.getIosUrl()
    },
    mounted(){
    
      if(this.$route.query.showTop){
        setTimeout(() => {
        this.scrollToTarget()
          
        }, 200);
      }
      const { origin } = window.location;
    
      const channel = this.appName == '乐富智享' ? '9947' : sessionStorage.getItem('channel');

      const Rhref = window.location.host;

      if (Rhref.indexOf('rlchltd') > -1) {
        var url = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'
        

      } else {
        var url = origin + '/subject/download?channel=' + channel

      }

      const icon = require('../../static/index/hongshi.jpg')

    generateQRCode(url, this.$refs.qrcodeCanvas, icon)
    },
    methods:{
      async getAndroidUrl(code) {
        const Rhref = window.location.host;

        if (Rhref.indexOf('rlchltd') > -1) {
          this.androidUrl = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'
        } else {
          const res = await getChannelInfo(code)
          const { downloadUrl } = res;
          this.APKurl = downloadUrl || '';
          const { origin } = window.location;
          const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
          if (absoluteURLRegex.test(downloadUrl)) {
            this.androidUrl = downloadUrl
          } else {
            this.androidUrl = origin + '/' + downloadUrl
          }
        }

      },
      //获取ios下载链接
      async getIosUrl() {
        const res = await getConfigurationValue({ key: 'H5URLBeforeA'})
        if(res) {
          this.iosUrl = await getActiveDomain(res)


        }
      },
      iosDownload(){
        // window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
        window.location.href = this.iosUrl;
      },
      androidDownload(){
        window.location.href = this.androidUrl;
      }  ,     
      // 点击跳转到指定位置
    scrollToTarget() {
      const targetElements = this.$refs.targetElement;
      const targetPosition = targetElements.offsetTop+380 ;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    },
   
      //获取ios下载链接
      async getIosUrl() {
        const res = await getConfigurationValue({ key: 'H5URLBeforeA'})
        if(res) {
          this.iosUrl = await getActiveDomain(res)
        }
      },
      iosDownload(){
        // window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
        window.location.href = this.iosUrl;
      },
      androidDownload(){
        window.location.href = this.androidUrl;
      }
    },
    computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.scrollTop;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    golds(){
      return this.$parent.goldData
    },
    high(){
      return this.$parent.goldData1
    },

    priceRange(){
    let value=(this.golds-this.high).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.high? ((Math.abs(value) * 100) / this.high).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     hk50(){
      return this.$parent.hk50
    },
    hk501(){
      return this.$parent.hk501
    },

    priceRange4(){
    let value=(this.hk50-this.hk501).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.hk501? ((Math.abs(value) * 100) / this.hk501).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     nas(){
      return this.$parent.nas
    },
    nas1(){
      return this.$parent.nas1
    },

    priceRange3(){
    let value=(this.nas-this.nas1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.nas1? ((Math.abs(value) * 100) / this.nas1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
    sliver(){
      return this.$parent.sliver
    },
    sliver1(){
      return this.$parent.sliver1
    },

    priceRange1(){
    let value=(this.sliver-this.sliver1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.sliver1? ((Math.abs(value) * 100) / this.sliver1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     usd(){
      return this.$parent.usd
    },
    usd1(){
      return this.$parent.usd1
    },

    priceRange2(){
    let value=(this.usd-this.usd1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.usd1? ((Math.abs(value) * 100) / this.usd1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
   
   
  },
   
  }
</script>

<style lang="less" scoped>
  .Appdownload{
    width: 100%;
    margin: 0 auto;
    text-align: center;
       .bigImg {
    width: 100%;
      height: 750px;
      background: url('../../static/wap/download/topbg.png') no-repeat;
      background-size: cover;
    background-size: cover;
    box-sizing: border-box;
    //   overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .title {
      font-size: 58px;
      line-height: 77px;
      color: #fff;
      font-weight: 700;
    }
    .titles {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      margin: 6px 0 24px 0;
    }
    .topimg {
      width: 110px;
      height: 30px;
      margin: 28px 0 6px 0;
    }
    .download {
      width: 180px;
      height: 34px;
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .flex1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    //市场
   .topbox {
      width: 86%;
      height: 40px;
      overflow: scroll;
      display: flex;
      position: absolute;
      left: 1rem;
      bottom: -4%;
      z-index: 10;
      white-space: nowrap;
      .boxs {
        width: 164px;
        height: 40px;
        background: #fff;
        color: #fff;
        margin-right: 10px;
        padding: 10px 12px;
        box-sizing: border-box;
        .left {
          background: #1552ac;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          font-size: 14px;
          line-height: 19px;
          margin-right: 7px
        }
        .right {
          font-size: 12px;
          line-height: 17px;
          .txt {
            font-size: 10px;
            color: #93939f;
            width: 36px;
          }
          .txts{
            color: #0F0F11;
            font-size: 12px;
            line-height: 17px;
            font-weight: 600;

          }
          .cont {
            display: flex;
            // flex-direction: column;
          }
        }
      }
    }
  }
   .indexTitle {
    font-size: 36px;
    line-height: 50px;
    color: #0f0f11;
    margin-top: 48px;
    span {
      color: #fa2314;
    }
    text-align: center;
  }
  .indexTitle1 {
    font-size: 14px;
    line-height: 20px;
    color: #0f0f11;
    margin: 6px 0 28px 0;
    span{
        font-weight: 700;
    }
  }
   .flexs {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;
  }
    .iconBox{
      width: 100%;
   
      box-sizing: border-box;
    
      padding: 48px 0;
      .indexTitle,.indexTitle1{
        margin: 0;
      }
      .ibsBox{
        width: 95%;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
      position: relative;

        .phone{
            position: absolute;
            bottom: -4%;
            left: 50%;
        }
        .phone1{
            position: absolute;
            bottom: -4%;
            left: 34%;
            z-index: 10;

        }
        .icon1,.icon2,.icon3,.icon4,.icon5,.icon6{
          width: 80px;
          height: 42px;
          position: absolute;

        }
        .icon1{
          top: 10%;
          left: 9%;
        }
        .icon2{
         
          left: 0;
          top: 40%;
        }
        .icon3{
          top: 70%;
          left: 5%;
        }
        .icon4{
          top: 11%;
          right: 9%;
        }
        .icon5{
          top: 40%;
          right: 0;
        }
        .icon6{
          top: 70%;
          right: 5%;
        }
        div{
          width: 48%;
          height: 2.45rem;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: 0.15rem;
          img{
            width: 0.9rem;
            height: auto;
            margin-bottom: 0.3rem;
          }
          span{
            font-size: 0.22rem;
            font-weight: 600;
            margin-bottom: 0.35rem;
          }
        }
      }
    }
     .part2 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
      background: url('../../static/wap/download/bottombg.png') no-repeat;
      mix-blend-mode: multiply; /* 使用multiply混合模式 */
    background-color: black; /* 叠加的颜色 */
  //  background-color: rgba(0, 0, 0, 0.8); /* 叠加的颜色 */
    background-size: 100% 100%;
    padding: 0 1rem;
    box-sizing: border-box;
    .indexTitle{
      color: #fff;
    }
    .indexTitle1 {
      width: 343px;
      text-align: left;
      color: #fff;
    }
    .phone {
      width: 241px;
      height: 385px;
      margin: 0 67px;
    }
    .part2-bott {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      flex-wrap: wrap;
      margin: 36px 0;
      div {
        display: flex;
        align-items: center;
        margin-bottom: 31px;
        .icons {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        span {
          font-size: 12px;
          line-height: 20px;
          color: #fff;
        }
      }
    }
    .part2-down {
      display: flex;
      align-items: center;
      .code {
        
        margin-right: 16px;
        .canvasCode{
           width: 156px;
        height: 156px;
        }
      }
      .download {
        width: 171px;
        height: 50px;
        margin-bottom: 16px;
      }
      span {
        color: #93939f;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  }
</style>